import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { ProcessCellForExportParams } from "ag-grid-community/dist/types/src/interfaces/exportParams";
import {
  ResourceIdentifierCellRenderer,
  resourceIdentifierCellRendererNoNamePlaceHolder,
} from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/resource-identifier/ResourceIdentifierCellRenderer";
import { readDataByDotSeparatedString } from "@/components/pages/common/ag-grid/utils/helpers/readDataByDotSeparatedString";

export const resourceIdentifierColumnDefColId =
  "resourceIdentifierColumnDefColId";

export const getResourceIdentifierColumnDef = (
  headerName = "Name",
  propName = "name",
): ColDef => {
  return {
    colId: resourceIdentifierColumnDefColId,
    pinned: "left",
    field: `resource.${propName}`,
    headerName: headerName,
    lockVisible: true,
    suppressColumnsToolPanel: true,
    valueGetter: ({ data }) => {
      return `${data?.resource?.[propName]}${data?.resource?.task?.status_id}${data?.resource?.task?.id}`;
    },
    comparator: (_, __, nodeA, nodeB) => {
      const current = nodeA.data?.resource?.[propName]?.toLowerCase() ?? "";
      const next = nodeB.data?.resource?.[propName]?.toLowerCase() ?? "";

      return current.localeCompare(next);
    },
    cellRenderer: ({ data, context }: ICellRendererParams) => {
      const resource = data?.resource;

      if (!resource) {
        return null;
      }

      return (
        <ResourceIdentifierCellRenderer
          resource={resource}
          name={resource[propName]}
          masterGridId={context?.masterGridId}
          preventDetailsDrawerOpener={!!context?.preventDetailsDrawerOpener}
        />
      );
    },
  };
};

export const resourceIdentifierColDefCSVValueGetter = ({
  column,
  node,
  value,
}: ProcessCellForExportParams) => {
  const field = column.getColDef().field;

  if (!field) {
    return value;
  }

  return (
    readDataByDotSeparatedString(field, node?.data) ||
    resourceIdentifierCellRendererNoNamePlaceHolder
  );
};
